export default __webpack_public_path__ + "3d52aef439316cc16e7a2d4ed65d1f10.png";